const PRETENDARD_STYLESHEET_ID = 'runtime-font-pretendard';
const JETBRAINS_MONO_STYLESHEET_ID = 'runtime-font-jetbrains-mono';

const PRETENDARD_STYLESHEET_HREF =
  'https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable-dynamic-subset.min.css';

const JETBRAINS_MONO_STYLESHEET_HREF =
  'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500&display=swap';

function appendStylesheetOnce(id: string, href: string) {
  if (typeof document === 'undefined') return;
  if (document.getElementById(id)) return;

  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = href;
  link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
}

function afterFirstPaint(callback: () => void) {
  if (typeof window === 'undefined') return;

  window.requestAnimationFrame(() => {
    window.setTimeout(callback, 0);
  });
}

export function scheduleRuntimeFontLoading() {
  if (typeof window === 'undefined') return;

  // 본문 폰트는 첫 페인트 직후 바로 로드해 FOUT는 짧게, 렌더 차단은 피한다.
  afterFirstPaint(() => {
    appendStylesheetOnce(PRETENDARD_STYLESHEET_ID, PRETENDARD_STYLESHEET_HREF);
  });

  const loadMonoFont = () => {
    appendStylesheetOnce(JETBRAINS_MONO_STYLESHEET_ID, JETBRAINS_MONO_STYLESHEET_HREF);
  };

  // 코드 폰트는 초기 화면에 필수는 아니라 idle 타이밍까지 미룬다.
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(loadMonoFont, { timeout: 1800 });
    return;
  }

  window.setTimeout(loadMonoFont, 1200);
}
